export function normalizeHouseNo(value) {
  return String(value || "").trim().toUpperCase();
}

export function isPaymentRecordForHouse(payload, houseNo) {
  const targetHouse = normalizeHouseNo(houseNo);
  if (!targetHouse) return false;

  const record = payload?.new || payload?.old || payload;
  if (!record || typeof record !== "object") return false;

  return normalizeHouseNo(record.nomor_rumah) === targetHouse;
}

export function filterPaymentRecordsForHouse(records, houseNo) {
  const targetHouse = normalizeHouseNo(houseNo);
  if (!targetHouse) return [];

  return (records || []).filter((record) => normalizeHouseNo(record?.nomor_rumah) === targetHouse);
}
